import { useRoute } from "@react-navigation/native";
import {
  Alert,
  ButtonBorder,
  Div,
  HeaderBack,
  ImageView,
  Label,
} from "components";
import { urlApp } from "constants/AppUrl";
import { Icons } from "constants/Icons";
import React, { useEffect, useRef, useState } from "react";
import { View } from "react-native";
import { apiAuth } from "services/api";
import { useNavigationLog } from "services/navigation";
import { convertDaTaCCCD } from "services/react_native_true_id";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { Log, getStoreData, setStoreData, setStoreToken } from "utils";
import { PostMSG } from "utils/utils";
import LangJson from "../trueidsdk/src/lang.json";
import { TrueIDResponse, UserDataEKYC } from "utils/ekycType";
import { getInfo } from "reducer/authen";

function ControlEKYCScreen() {
  const route = useRoute<any>();
  const countTime = useRef<number>(1);
  const [loading, setLoading] = useState(false);
  const [loadingTrueID, setLoadingTrueID] = useState(false);
  const currentUser = useAppSelector((state) => state.authen.currentUser);
  const navigate = useNavigationLog();
  const dispatch = useAppDispatch();

  useEffect(() => {
    loadTrueIdSDK();
  }, []);

  const loadTrueIdSDK = async () => {
    try {
      setLoadingTrueID(true);
      await import("../trueidsdk/public/trueidsdk/TrueIDSDK");
      Log("success");
    } catch (err) {
      Log("err Load trueid>", err);
    } finally {
      setLoadingTrueID(false);
    }
  };

  const getAccountToken = async () => {
    try {
      setLoading(true);
      const res = await apiAuth.login({
        username: route.params?.data?.phone,
        password: route.params?.data?.password,
      });
      if (res.status == 200) {
        await setStoreToken(res.data.access_token);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const checkCameraAccess = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      // Dừng stream sau khi kiểm tra
      stream.getTracks().forEach((track) => track.stop());
      return true; // Quyền truy cập camera được cấp
    } catch (error) {
      console.error("Camera access denied", error);
      return false; // Quyền truy cập camera bị từ chối
    }
  };

  const mapDataEKYC = async (result: TrueIDResponse) => {
    Log("SDK result>>", result);

    if (!result.ekycResult) {
      Log("scanData is null");
      return;
    }
    getAccountToken();
    // check & do action

    const editOCR = result.editOCR;
    const obj = await convertDaTaCCCD(result);
    if (result.ekycResult?.kyc_result?.decision?.code == -1) {
      Alert.showError({
        content: `alert.ekycfail`,
        onPress: () => {
          if (countTime.current >= 3) {
            navigate("LoginScreen");
            return;
          }
          gotoEKYC();
          countTime.current += 1;
        },
      });
      return;
    }
    const idNo = await getStoreData("idNo");
    const phone = await getStoreData("phone");
    if (idNo)
      if (
        (idNo && idNo != editOCR?.idNumber) ||
        (phone && phone != route.params?.data?.phone)
      ) {
        Alert.showError({
          content: `Số giấy tờ tùy thân đăng ký tại Ngân hàng đang khác với số giấy tờ tùy thân sử dụng đăng ký mở tài khoản. Quý khách vui lòng kiểm tra lại`,
          multilanguage: false,
          type: 2,
          onClose: () => {
            PostMSG("CreateAccountFailure", {});
          },
          onPress: () => {
            PostMSG("CreateAccountFailure", {});
          },
          onCancel: () => {
            PostMSG("CreateAccountFailure", {});
          },
          onConfirm: () => {
            PostMSG("CreateAccountFailure", {});
          },
        });
        return;
      }

    navigate("ReviewInfoModal", {
      data: {
        ...obj,
        currentUser: {
          ...currentUser,
          phone: route.params?.data?.phone || undefined,
          password: route.params?.data?.password || undefined,
          name: route.params?.data?.name || undefined,
          email: route.params?.data?.email || undefined,
        },
      },
    });
    return;
  };

  const gotoEKYC = async () => {
    const hasCameraAccess = await checkCameraAccess();
    if (!hasCameraAccess) {
      Alert.showError({
        content: "alert.cameraPermission",
        multilanguage: true,
      });
      return;
    }

    if (window?.["TrueIDSDK"] && window?.["TrueIDSDK"].start) {
      const res = await apiAuth.login({
        username: route.params?.data?.phone,
        password: route.params?.data?.password,
      });

      if (res.status == 200) {
        await setStoreToken(res.data.access_token);
        await dispatch(getInfo({}));

        let configEkyc = {
          domain: `${urlApp.APIURL}api`,
          configEndpoint: {
            front: "/ekyc/v1.2/id/verify/front",
            back: "/ekyc/v1.2/id/verify/back",
            selfie: "/ekyc/v1.2/face/liveness",
            complete: "/ekyc/v1.2/complete",
            nfcqrverify: "/ekyc/v2.0/nfcqr/verify",
            nfcrar: "/ekyc/v1.2/nfcqr/upload",
            ocr: "/ekyc/v1.2/id/ocr",
            nfcbshield: "/ekyc/v1.2/nfcqr/upload",
            createrequest: "/ekyc/v1.2/request/create",
            accesstoken: "/auth/v1/oauth/accessToken",
          },
          clientId: "ea8df9ebff8d38479058d7f1d235e097",
          clientSecret: "",
          configHeader: "",
          stepVerification: ["FRONT", "BACK", "SELFIE", "EDITOCR"],
          titleColor: "#091E42CC", //80%
          subTitleColor: "#091E4299", //60%
          closeColor: "#091E42CC", //80%
          buttonCaptureColor: "#ed1c24",
          titleButtonCaptureColor: "#ffffff",
          ovalColor: "#ed1c24",
          stepBarColor: "#ed1c24",
          stepBarBackgroundColor: "#D3D9E0",
          backgroundColor: "#ffffff",
          requestId: "",
          accessToken: res.data.access_token,
          sdkKey: "",
          libFacePath: [
            "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision/wasm",
            "https://storage.googleapis.com/mediapipe-models/face_detector/blaze_face_short_range/float16/1/blaze_face_short_range.tflite",
          ],
          ocrFieldsConfig: {
            fullName: { visible: true, editable: true },
            dateOfBirth: { visible: true, editable: true },
            gender: { visible: true, editable: false },
            idNumber: { visible: true, editable: true },
            givenDate: { visible: true, editable: true },
            dueDate: { visible: true, editable: true },
            placeOfIssue: { visible: true, editable: true },
            permanentAddress: { visible: true, editable: false },
          },
        };

        window?.["TrueIDSDK"].setLanguageJson("vi", LangJson);
        window?.["TrueIDSDK"].start(configEkyc, mapDataEKYC);

        // === old version ===
        // var event = new CustomEvent("start", {
        //   detail: {
        //     config: {
        //       domain: `${urlApp.APIURL}api`,
        //       domainPath: "/ekyc/v1.2",
        //       authDomain: "https://api.trueid.ai",
        //       authDomainPath: "/v1/oauth",
        //       appId: "ea8df9ebff8d38479058d7f1d235e097",
        //       appSecret: "",
        //       lang: "vi",
        //       accessToken: res.data.access_token,
        //       theme: {
        //         backgroundColor: "#ffffff",
        //         borderColor: "#efe8df",
        //         errorColor: "#e87722",
        //         primaryColor: "#ed1c24",
        //         secondaryColor: "#efe8df",
        //         textColor: "#231f20",
        //       },
        //     },
        //   },
        // });
        // document.dispatchEvent(event);
      }
    } else {
      Log("NULL");
    }
  };

  return (
    <Div screen={true}>
      <HeaderBack
        isShowStep={true}
        step={3}
        type={4}
        onGoBack={() => {
          navigate("LoginScreen");
        }}
        title={`setpasswordscreen.titletrong`}
      />
      <Div paddingHorizontal={29}>
        <Div width={"100%"} alignItems={"center"}>
          <Label
            marginTop={30}
            textAlign={"center"}
            size={20}
            fontWeight={"700"}
          >
            {`controlekyc.xacthucthongtin`}
          </Label>
          <Label marginTop={6} textAlign={"center"} size={14} lineHeight={20}>
            {`controlekyc.content`}
          </Label>
        </Div>
        <Label marginTop={40} size={14} lineHeight={20}>
          {`controlekyc.chuphinhmattruoc`}
        </Label>
        <Div
          flexDirection={"row"}
          marginTop={17}
          alignItems={"center"}
          justifyContent={"flex-start"}
        >
          <ImageView
            width={132}
            height={100}
            resizeMode={"contain"}
            source={Icons.before}
            marginRight={11}
          />
          <ImageView
            width={132}
            height={100}
            resizeMode={"contain"}
            source={Icons.after}
          />
          <ImageView
            height={1}
            resizeMode={"contain"}
            width={1}
            source={Icons.a}
          />
          <ImageView
            height={1}
            resizeMode={"contain"}
            width={1}
            source={Icons.closeee}
          />
          <ImageView
            height={1}
            resizeMode={"contain"}
            width={1}
            source={Icons.checked}
          />
          <ImageView
            height={1}
            resizeMode={"contain"}
            width={1}
            source={Icons.iconid}
          />
          <ImageView
            height={1}
            resizeMode={"contain"}
            width={132}
            source={Icons.id_card}
          />
          <ImageView
            height={1}
            resizeMode={"contain"}
            width={132}
            source={Icons.f}
          />
        </Div>
        <Label marginTop={18} size={14} lineHeight={20}>
          {`controlekyc.chuphinhchandung`}
        </Label>
        <Div>
          <ImageView
            height={100}
            marginTop={17}
            width={132}
            source={Icons.cmnd}
            resizeMode={"contain"}
          />
        </Div>
      </Div>
      <Div alignItems={"center"}>
        <ButtonBorder
          loading={loading == true || loadingTrueID == true}
          onPress={() => {
            gotoEKYC();
          }}
          marginTop={30}
          type={1}
          title={"controlekyc.batdau"}
        />
      </Div>
      <View nativeID={"trueidsdk"} />
    </Div>
  );
}

export default React.memo(ControlEKYCScreen);
